export enum StorageEnum {
    userToken = 'fluid-token',
    userData = 'fluid-user',
    businessId = 'fluid-userbusinessId',
    userBusinessDetails = 'fluid-business-detail',
    selectedOrderTabId = 'fluid-selected-order-tab-Id',
    selectedOrderOption = 'fluid-selected-order-option',
    fluidAuthId = 'fluid-auth-id',
    jwtPayload = 'fluid-jwt-payload',
    selectedOrganizationId = 'fluid-selected-organization-id',
}

export enum UserRoleEnum {
    admin = "Admin",
    partner = "Partner",
}

export enum PermissionEnum {
    headOffice = "head-office",
    deliveryPartner = "delivery-partner",
    warehouseManager = "warehouse-manager",
    orderTracking = "order-tracking",
    tradeMembers = "trade-members",
    dispatchOrder = "dispatch-order",
    driver = "driver",
    clusterAccess = "cluster-access",
}